// THIS FILE WAS AUTOGENERATED BY SVGR. DO NOT MODIFY IT MANUALLY;
import { Ref, SVGProps, forwardRef, memo } from 'react'

const SvgOtherBenefitCardPattern2 = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width={216}
    height={216}
    viewBox="0 0 216 216"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g clipPath="url(#clip0_1505_4344)">
      <path d="M162 215.98c-29.46-.781-53.199-24.52-53.98-53.98H162v53.98Z" fill="#C2E0FF" fillOpacity={0.2} />
    </g>
    <g clipPath="url(#clip1_1505_4344)" fill="#BCD5FA" fillOpacity={0.08}>
      <path d="M162 156h54v6h-54v-6ZM162 108h54v6h-54v-6ZM216 120h-54v6h54v-6ZM162 144h54v6h-54v-6ZM216 132h-54v6h54v-6Z" />
    </g>
    <path d="M0 216h54v-54H0v54Z" fill="#BCD5FA" fillOpacity={0.08} />
    <path
      d="M162 108h-6v-6h6v6ZM144 78h6v6h-6v-6ZM138 78v6h-6v-6h6ZM138 72v6h6v-6h6v-6h-6v6h-6ZM132 72v-6h6v6h-6ZM126 72h6v6h-6v-6ZM126 84h-6v-6h6v6ZM126 90h-6v6h6v-6ZM126 90v-6h6v6h-6ZM126 72v-6h-6v6h6Z"
      fill="#C2E0FF"
      fillOpacity={0.2}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M150 102h6v-6h6v-6h-6v-6h6v-6h-6v-6h6v-6h-6v-6h6v-6h-6v6h-6v-6h-6v6h-6v-6h-6v6h-6v-6h-6v6h-6v-6h-6v6h6v6h-6v6h6v6h-6v6h6v6h-6v6h6v6h-6v6h6v-6h6v6h6v-6h6v6h6v-6h6v6h6v-6Zm0-6v6h-6v-6h6Zm0-6v6h6v-6h-6Zm-6 0v6h-6v-6h6Zm0-6v6h6v-6h6v-6h-6v-6h6v-6h-6v-6h-6v6h-6v-6h-6v6h-6v-6h-6v6h-6v6h6v6h-6v6h6v6h-6v6h6v6h6v-6h6v6h6v-6h-6v-6h6v-6h6Z"
      fill="#C2E0FF"
      fillOpacity={0.2}
    />
    <path
      d="M54 108h6v6h-6v-6ZM72 138h-6v-6h6v6ZM78 138v-6h6v6h-6ZM78 144v-6h-6v6h-6v6h6v-6h6ZM84 144v6h-6v-6h6ZM90 144h-6v-6h6v6ZM90 132h6v6h-6v-6ZM90 126h6v-6h-6v6ZM90 126v6h-6v-6h6ZM90 144v6h6v-6h-6Z"
      fill="#C2E0FF"
      fillOpacity={0.2}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M66 114h-6v6h-6v6h6v6h-6v6h6v6h-6v6h6v6h-6v6h6v-6h6v6h6v-6h6v6h6v-6h6v6h6v-6h6v6h6v-6h-6v-6h6v-6h-6v-6h6v-6h-6v-6h6v-6h-6v-6h6v-6h-6v6h-6v-6h-6v6h-6v-6h-6v6h-6v-6h-6v6Zm0 6v-6h6v6h-6Zm0 6v-6h-6v6h6Zm6 0v-6h6v6h-6Zm0 6v-6h-6v6h-6v6h6v6h-6v6h6v6h6v-6h6v6h6v-6h6v6h6v-6h6v-6h-6v-6h6v-6h-6v-6h6v-6h-6v-6h-6v6h-6v-6h-6v6h6v6h-6v6h-6Z"
      fill="#C2E0FF"
      fillOpacity={0.2}
    />
    <path d="M216 0h-54v54h54V0Z" fill="#BCD5FA" fillOpacity={0.08} />
    <g clipPath="url(#clip2_1505_4344)" fill="#BCD5FA" fillOpacity={0.08}>
      <path d="M54 60H0v-6h54v6ZM54 108H0v-6h54v6ZM0 96h54v-6H0v6ZM54 72H0v-6h54v6ZM0 84h54v-6H0v6Z" />
    </g>
    <g clipPath="url(#clip3_1505_4344)">
      <path d="M54 .02C83.46.8 107.199 24.54 107.98 54H54V.02Z" fill="#C2E0FF" fillOpacity={0.2} />
    </g>
    <defs>
      <clipPath id="clip0_1505_4344">
        <path fill="#fff" transform="rotate(-180 81 108)" d="M0 0h54v54H0z" />
      </clipPath>
      <clipPath id="clip1_1505_4344">
        <path fill="#fff" transform="rotate(-180 108 81)" d="M0 0h54v54H0z" />
      </clipPath>
      <clipPath id="clip2_1505_4344">
        <path fill="#fff" transform="translate(0 54)" d="M0 0h54v54H0z" />
      </clipPath>
      <clipPath id="clip3_1505_4344">
        <path fill="#fff" transform="translate(54)" d="M0 0h54v54H0z" />
      </clipPath>
    </defs>
  </svg>
))
SvgOtherBenefitCardPattern2.displayName = 'SvgOtherBenefitCardPattern2'
const Memo = memo(SvgOtherBenefitCardPattern2)
export { Memo as SvgOtherBenefitCardPattern2 }
